import { Component, forwardRef, Injector, Input } from '@angular/core';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';

import { iif, Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';

import {
  UserChipsAutocompleteComponent
} from '@components/chips-autocomplete/user-chips-autocomplete/user-chips-autocomplete.component';
import { EMPTY_AUTOCOMPLETE_VALUE } from '@configs/autocomplete';
import { AutocompleteValue, EmptyAutocompleteValue } from '@models/autocomplete';
import { User } from '@models/user';

@Component({
  selector: 'app-client-chips-autocomplete',
  templateUrl: './client-chips-autocomplete.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef((): any => ClientChipsAutocompleteComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: ClientChipsAutocompleteComponent,
      multi: true
    }
  ]
})
export class ClientChipsAutocompleteComponent extends UserChipsAutocompleteComponent {
  @Input() public override startWith: boolean = true;
  @Input() public override addKeywordFromInput: boolean = true;

  protected override readonly switchMap: boolean = true;

  constructor(injector: Injector) {
    super(injector);
  }

  protected override onInputValueChange(query: string | AutocompleteValue): Observable<Array<AutocompleteValue>> {
    return this.searchByQuery(<string>query);
  }

  protected override searchByQuery(query: string): Observable<Array<AutocompleteValue>> {
    return this.api.searchForUsersByRole(
      'client',
      {page: 1, limit: 10, keyword: query}
    ).pipe(
      tap((clients: Array<User>): Array<User> => this.allItems = clients),
      map((): Array<AutocompleteValue> => this.composeAutocompleteValues()),
      catchError((): Observable<Array<EmptyAutocompleteValue>> => of(EMPTY_AUTOCOMPLETE_VALUE))
    );
  }
}
